<div class="layout-topbar">
    <a class="layout-topbar-logo" routerLink="home">
        <img src="assets/layout/images/logo.png" alt="logo">
        <span>TBOLIVIA</span>
    </a>

    <button #menubutton class="p-link layout-menu-button layout-topbar-button" (click)="layoutService.onMenuToggle()">
        <i class="pi pi-bars"></i>
    </button>

    <button #topbarmenubutton class="p-link layout-topbar-menu-button layout-topbar-button"
        (click)="layoutService.showProfileSidebar()">
        <i class="pi pi-ellipsis-v"></i>
    </button>

    <div #topbarmenu class="layout-topbar-menu"
        [ngClass]="{'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible}">
        <button class="p-link layout-topbar-button" [routerLink]="'/training'">
            <i class="pi pi-youtube"></i>
            <span>Capacitacion</span>
        </button>
        <button class="p-link layout-topbar-button" [routerLink]="'/documentation'">
            <i class="pi pi-file"></i>
            <span>Documentacion</span>
        </button>
        <button class="p-link layout-topbar-button" (click)="cerrarSesion()">
            <i class="pi pi-sign-in"></i>
            <span>Cerrar Sesión</span>
        </button>
    </div>
</div>